<template>
   <div>
      <div class="d-flex flex-row flex-column-fluid">
         <div class="main d-flex flex-column flex-row-fluid">
            <div id="kt_subheader" class="subheader py-2 py-lg-6 bg-white">
               <div class="w-100 d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap">
                <div>
                  <div v-if="show_product_view" class="d-flex align-items-center flex-wrap mr-1">
                     <div class="d-flex align-items-baseline flex-wrap mr-5">
                        <h3 class="text-dark font-weight-bolder">{{$t('shop')}}
                        </h3>
                         <ul class="breadcrumb breadcrumb-transparent breadcrumb fs-6 font-weight-bold p-0 my-2 font-size-sm">
                            <li class="breadcrumb-item px-3 text-muted">{{$t('shop')}}</li> 
                        </ul>
                     </div>
                  </div>
                  <div v-else class="d-flex" id="kt_content">
                     <h3 class="text-dark font-weight-bolder">{{$t('shop')}}</h3>
                     <span class="subheader__separator subheader__separator--v"></span>
                      <ul class="breadcrumb breadcrumb-transparent breadcrumb-dot font-weight-bold p-0 my-2 mx-2 font-size-sm"  v-for="(category, index) in categoriesBreadCrumbs" :key="index">
                          <li class="breadcrumb-item">
                              <a class="text-muted" @click="breadCrumbs({category:category.categories, direction:'bwd', index})">{{category.name}}</a>
                          </li>
                          <span v-if="index !== categoriesBreadCrumbs.length-1"> . </span>
                      </ul>
                  </div>
                </div>
                <div class="d-flex align-items-center flex-wrap flex-sm-nowrap">
                     <template  v-if="show_product_view" class="flex-wrap">
                        <div class="d-flex align-items-center mobile-buttons mobile-select">
                              <select class="form-control mr-3" v-model="selectedCategory" @change="sortByCategory()">
                                <option v-if="!isBambuFranchising" value="">{{$t('filter_categories')}}</option>
                                <template v-for="(category, index) in categoriesListDropDown"> 
                                    <option v-if="category.show_category_filter == 1 || category.filterlist == 1" :class="'subcategory-' + category.level" :key="index" :value="category.id">{{ category.name}}
                                </option>
                                </template>
                              </select>
                        </div>
                        <div  class="d-flex align-items-center mobile-buttons mobile-select">
                           <select class="form-control mr-3 form-elements" v-model="sortingType" @change="sortingChange()">
                              <option value="default">{{$t('sort_by_default')}}</option>
                              <option value="name">{{$t('alphabetically_a_z')}}</option>
                              <option value="-name">{{$t('alphabetically_z_a')}}</option>
                              <!-- <option value="price">{{$t('price_low_to_high')}}</option> -->
                              <!-- <option value="-price">{{$t('price_high_to_low')}}</option> -->
                              <option value="created">{{$t('oldest')}}</option>
                              <option value="-created">{{$t('recent')}}</option>
                              <option value="order">{{$t('Product Order')}}</option>
                           </select>
                        </div>
                     </template>
                     <button type="button" class="btn btn-link mobile-buttons" v-show="enableFilter" @click="clearCategoryFilter">(Clear Filters)</button>
                    <div class="d-flex flex-wrap align-items-center" :class="{ 'category-view-controls': !show_product_view }">
                        <div class="btn-group btn-group-toggle mobile-buttons mr-2" data-toggle="buttons"  v-if="show_product_view">
                            <label class="btn btn-default btn-shadow-hover font-weight-bold" :class="store.getters.brand.show_default_view=='1' ? 'active' : ''">
                                <input @click="switchProductListView " type="radio"  name="options" id="option1" :checked="store.getters.brand.show_default_view=='1' ? 'checked' : ''"/> <i class="flaticon-grid-menu"></i> {{$t('grid')}}
                            </label>
                            <label class="btn btn-default btn-shadow-hover font-weight-bold" :class="store.getters.brand.show_default_view=='0' ? 'active' : ''">
                                <input @click="switchProductGridView" type="radio" name="options" id="option2" :checked="store.getters.brand.show_default_view=='0' ? 'checked' : ''"/> <i class="flaticon2-indent-dots"></i> {{$t('list')}}
                            </label>
                        </div>
                        <button v-if="show_product_view===true" type="button" class="btn btn-primary mr-2 mobile-buttons"  :style="primaryBtnColor"  @click="switchProductCategoryPage">
                            {{ store.getters.brand['subdomain'] == 'verityrx' ? $t('View Categories') : $t('View Category List') }}</button>
                        <button v-if="show_product_view===false" type="button" class="btn btn-primary mr-2 mobile-buttons"  :style="primaryBtnColor"  @click="switchProductCategoryPage"> {{$t('View Product List')}}</button>
                        <div class="btn-group btn-group-toggle mobile-buttons mr-2" data-toggle="buttons"  v-if="show_product_view === false && listOfCategories.length>1">
                            <label class="btn btn-default btn-shadow-hover font-weight-bold" :class="showCategoryView===true ? 'active' : ''">
                                <input @click="switchCategoryTreeView" type="radio"  name="options" id="option1" :checked="showCategoryView===true ? 'checked' : ''"/> <i class="flaticon2-layers"></i> {{$t('tree_view')}}
                            </label>
                            <label class="btn btn-default ml-2 btn-shadow-hover font-weight-bold" :class="showCategoryView===false ? 'active' : ''">
                                <input @click="switchCategoryListView" type="radio" name="options" id="option2" :checked="showCategoryView===false ? 'checked' : ''"/> <i class="flaticon2-indent-dots"></i> {{$t('list_view')}}
                            </label>
                        </div>
                    </div>
                </div>
               </div>
            </div>
            <div class="content flex-column-fluid bg-white mt-5 py-5" id="kt_content">
                <div v-if="order_link != '' && order_link != undefined && order_text != '' && order_text != undefined && $store.getters.brand['subdomain'] != 'seahorsechocolate' && $store.getters.brand['subdomain'] != 'gofericecream'" class="alert alert-warning alert-custom">
                    {{$t('you_have')}} <router-link class="text-white ml-2" :to="order_link"><u>{{order_text}}</u></router-link>. {{$t('make_alternative_payment_method')}}
                </div>
                <div v-else-if="order_link != '' && order_link != undefined && order_text != '' && order_text != undefined && store.getters.brand['subdomain'] == 'seahorsechocolate' && !store.state.user?.user?.hasOwnProperty('role')" class="alert alert-warning alert-custom">
                    {{$t('you_have')}} <router-link class="text-white ml-2" :to="order_link"><u>{{order_text}}</u></router-link>. {{$t('make_alternative_payment_method')}}
                </div>
                <div class="seperator seperator-solid"></div>
                <div class="input-icon w-100 mobile-product-search" v-show="toggler" v-if="store.getters.brand.show_default_product_search==='0'">
                    <input type="text" :placeholder="$t('Type product number or SKU')" id="generalSearch" class="form-control form-elements" v-model="searchValue" @keyup="loadShopData(pageNumber,paginationSize, $event)" data-toggle="tooltip" data-original-title="Type product number or SKU to search" data-placement="bottom">
                    <span>
                    <i class="flaticon2-search-1 text-muted"></i>
                    </span>
                </div>
                <div class="col-md-12 p-0 mobile-product-search" v-if="store.getters.brand.show_default_product_search==='1'">
                    <multiselect class="products" input-class="form-control"  :max-height="400" :searchable="true" 
                     :allow-empty="false"  :placeholder="$t('You can Search Product or Product Variants')" :options="productVariants" track-by="n" 
                     label="n" :multiple="true" @select="productSelectedForOrder($event,productVariants.indexOf($event))" :close-on-select="false" :clear-on-select="true"
                     select-label="Press Enter to add Cart">
                        <span>No Products found.</span>
                    </multiselect>
                </div>
                <div v-if="subCategories.length>0 && show_product_view" class="row my-2">
                  <div v-for="(subCategory, index) in subCategories" :key="index" :class="columnClass">
                    <div :class="show_list_view== true ? 'custom-card' : ''">
                        <div class="card card-custom card-stretch gutter-b mt-5">
                            <div  class="card-body">
                                <div class="d-flex justify-content-between flex-column pt-4 h-100"  v-if="show_list_view==true">
                                    <div class="pb-5">
                                        <div class="d-flex flex-column flex-center">
                                            <div class="" @click="subCategoryProduct(subCategory.id)">
                                                <span class="">
                                                    <img v-if="subCategory.category_image" :src="getBrandImageUrl('/uploads/category/'+subCategory.category_image)" alt="image" class="bg-img-height rounded" />
                                                    <img v-else src="/images/no-image-500x500.jpg" alt="image" class="bg-img-height rounded" />
                                                </span>
                                            </div>
                                            <a href="#" class="card-title font-weight-bolder text-dark-75 text-hover-primary font-size-h5 m-0 pt-7 pb-3" @click="subCategoryProduct(subCategory.id)">{{subCategory.name}}</a>
                                            <button class="btn btn-link" id="view-image" v-if="subCategory.category_image"   @click="dialog = !dialog" >View Image</button>
                                            <button type="button" class="btn btn-success btn-elevate btn-pill btn-elevate-air btn-icon" data-toggle="tooltip" 
                                                title="Products" data-placement="bottom" data-skin="brand" @click="subCategoryProduct(subCategory.id)">
                                                <i class="flaticon2-box-1"></i></button>
                                           
                                        </div>
                                    </div>
                                </div>
                                <div v-if="show_list_view==false">
                                    <div  class="datatable datatable-bordered datatable-head-custom datatable-default datatable-primary datatable-loaded" id="kt_datatable" style="">
                                        <table class="datatable-table" style="display: block;">
                                            <tbody style="" class="datatable-body">
                                                <tr class="datatable-row" style="left: 0px;">
                                                    <td data-field="ShipName" data-autohide-disabled="true" class="datatable-cell">
                                                        <span>
                                                            <div class="d-flex align-items-center" >
                                                                <div class="symbol symbol-40 symbol-sm flex-shrink-0 ml-4">
                                                                    <img v-if="subCategory.category_image" :src="getBrandImageUrl('/uploads/category/'+subCategory.category_image)" alt="photo"/>
                                                                    <img v-else src="/images/no-image-500x500.jpg" alt="photo"/>
                                                                </div>
                                                                <div class="ml-4">
                                                                    <div class=" font-weight-bolder font-size-lg mb-0">
                                                                        <h6 class="font-size-h6 mt-3 text-hover-primary" @click="subCategoryProduct(subCategory.id)">{{subCategory.name}} </h6>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </span>
                                                    </td>
                                                    <td><span style="width:252px"></span></td>
                                                   
                                                    
                                                    <td>
                                                       <span style="width:252px">
                                                        <button class="btn btn-link" id="view-image" v-if="subCategory.category_image" @click="dialog = !dialog" >View Image</button>
                                                       </span>
                                                    </td>
                                                    <td><span style="width:252px"></span></td>
                                                    <td><span style="width:252px"></span></td>
                                                    <td class="datatable-cell">
                                                        <button type="button" class="btn btn-success btn-elevate btn-pill btn-elevate-air btn-icon" data-toggle="tooltip" 
                                                            title="Products" data-placement="bottom" data-skin="brand" @click="subCategoryProduct(subCategory.id)">
                                                            <i class="flaticon2-box-1"></i>
                                                        </button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="vgs" v-if="dialog">
                        <button type="button" id="close-modal"  @click="dialog = !dialog"  class="vgs__close"> ×</button>
                        <div class="vgs__container">
                            <img v-if="subCategory && subCategory.category_image" :src="'/uploads/category/'+subCategory.category_image"  alt="image" class="vgs__container__img"> 
                        </div> 
                    </div>  
                  </div>  
                  <div class="separator my-5"></div>
                </div>
               <div v-if="showShop && show_product_view" :class="classForListViewRow" >
                  <h3 class="subheader__title pl-4 pt-5" v-show="productsList.length == 0">{{$t('no_products_available')}}</h3>
                     <div :class="classForListViewColumn" id="content" v-for="(product, index) in productsList" :key="index">
                         <ProductComponent :key="componentKey" :product="product" :listOrGrid="show_list_view" :settings="shopSettings" v-on:loadGallery="loadImageGallery" v-on:openDetails="openModal">
                         </ProductComponent>
                      </div>
               </div>
               <div v-if="!show_product_view && shopSettings.show_category_tile" class="row">
                 <h3 class="subheader__title pl-4 pt-5" v-show="categoriesList.length == 0">{{$t('no_categories_found')}}</h3>
                 <div  class="col-md-3" v-for="(category, index) in categoriesList" :key="index">
                   <template v-if="(category.level == 0 || isSubcategory) && previewParent">
                        <CategoryComponent  :preview-parent="previewParent" :category="category" v-on:filteringCategory="filteringCategory" v-on:subCategories="breadCrumbs"></CategoryComponent>
                   </template>
                  </div>
               </div>
               <div v-if="!show_product_view && shopSettings.show_category_tile" class="row">
                   <div v-if="!previewParent" class="col-md-3" v-for="(categoryList,i) in listOfCategories" :key="i" >
                       <CategoryComponent :category-list="categoryList" :preview-parent="previewParent" v-on:filteringCategory="filteringCategory"></CategoryComponent>
                   </div>
               </div>
               <div v-if="store.getters.brand['subdomain'] == 'nursewellness'" class="row mb-5">
                  <div class="col-xl-12">
                     <div class="card card-custom" style="background:linen;">
                        <div class="card-body">
                            <strong>DISCLAIMER:</strong>
                            <p>
                                The statements made regarding these products have not been evaluated by the Food and Drug Administration. 
                                The efficacy of these products has not been confirmed by FDA-approved research. These products are not intended to diagnose, treat, 
                                cure or prevent any disease. All information presented here is not meant as a substitute for or alternative to information from health 
                                care practitioners. Please consult your health care professional about potential interactions or other possible complications before using 
                                any product.
                            </p>
                        </div>
                     </div>
                  </div>
                  <div class="col-xl-12">
                    <img class="card-brands" src="/images/card_brands.jpeg" alt="Card Brands" />
                  </div>
               </div>
               <div v-if="show_product_view" class="row">
                  <div class="col-xl-12">
                     <div class="card card-custom">
                        <div class="card-body">
                           <div class="pagination pagination--brand">
                              <div class="pagination__toolbar">
                                 <select class="form-control font-brand form-elements" @change="onPageSizeChange($event.target.value)" v-model="paginationSize">
                                    <option value="10">10</option>
                                    <option value="15">15</option>
                                    <option value="20">20</option>
                                    <option value="25">25</option>
                                    <option value="50">50</option>
                                    <option value="100">100</option>
                                    <option value="1000">1000</option>
                                 </select>
                              </div>
                                <Bootstrap4Pagination :data="paginatedData" @pagination-change-page="loadShopData" :limit="2"></Bootstrap4Pagination>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
      <button v-if="store.state.is_customer !== true" type="button" class="mobile-end-customer-preview" :disabled="endingCustomerPreview" @click="endCustomerPreview">
        <i class="fa fa-eye" aria-hidden="true"></i><span>{{ t('end_customer_preview') }}</span>
      </button>
      <Refferal></Refferal>
      <component
        :is="openVariantModal ? openVariantModal : 'div'"
        :product="product"
        :settings="shopSettings"
        :product_details="true"
        >
        <!-- <div v-if="!openVariantModal">Component not found</div> -->
      </component>
      <!-- <component :is="openVariantModal" :product="product" :settings="shopSettings" :product_details="true"></component> -->
      <!-- <vue-gallery-slideshow :images="productImage" :index="index" @close="index = null"></vue-gallery-slideshow> -->
   </div>
</template>
<script setup>
   import ProductComponent from '@/js/ordercircle/brands/store/product-component.vue';
   import CategoryComponent from '@/js/ordercircle/brands/store/category-component.vue';
   import ShopAPIService from '@/js/api/store/shop';
   import LoginAPIService from '@/js/api/auth/auth';
   import {Bootstrap4Pagination } from 'laravel-vue-pagination';
   import ProductVariants from '@/js/ordercircle/brands/store/product-variants.vue';
   import Refferal from '@/js/ordercircle/brands/orders/friendReferal.vue';
   
//    import Bugsnag from '@bugsnag/plugin-vue';
   import Multiselect from 'vue-multiselect';

   import { ref, onMounted, computed, nextTick, watch } from 'vue';
   import eventBus from '@/js/utils/eventBus';
   import {toast} from "vue3-toastify";
   import 'vue3-toastify/dist/index.css';
   import { useStore } from 'vuex';
   import { useI18n } from 'vue-i18n';
   import { getBrandImageUrl } from '@/js/utils/common.js';

   const store = useStore();
   const { t } = useI18n();
   const isBambuFranchising = computed(() => store.getters.brand['subdomain'] === 'bambufranchisingllc');

   const productsList = ref({});
   const paginatedData = ref({});
   const product = ref({});
   const productLength = ref(0);
   const paginationSize = ref(store.getters.brand.default_page_size);
   const pageNumber = ref(1);
   const productImage = ref([]);
   const index = ref(null);
   const showShop = ref(true);
   const searchValue = ref('');
   const shopSettings = ref({});
   const sortingType = ref('');
   const categoriesList = ref([]);
   const categoriesBreadCrumbs = ref([]);
   const categoriesListDropDown = ref([]);
   const selectedCategory = ref('');
   //Switch Between Category and Products
   const show_product_view = ref(true);
   const product_view_text = ref(t('View Product List'));
   const toggler = ref(true);
   //Switch Between List View and Grid ViewProducts
   const show_list_view = ref(true);
   const classForListViewRow = ref('row');
   const classForListViewColumn = ref('col-md-3');
   const isSubcategory = ref(false);
   const enableFilter = ref(false);
   const openVariantModal = ref('');
   const showCategoryView = ref('');
   const previewParent = ref(true);
   const listOfCategories = ref([]);
   const order_link = ref('');
   const order_text = ref('');
   const selectedVariant = ref('');
   const componentKey = ref(0);
   const product_collection_sort_check = ref(true);
   const productVariants = ref([]);
   const subCategories = ref([]);
   const dialog = ref(false);
   const product_collection_filter = ref([]);
   const endingCustomerPreview = ref(false);
   const APIURL = import.meta.env.VITE_API_URL;

    onMounted(() => {
    // Set initial sorting type and load shop data
    sortingType.value = store.getters.brand.shop_sort_by_default;
    loadShopData(pageNumber.value, paginationSize.value);

    // Simplify conditional assignments
    const isVerityRx = store.getters.brand['subdomain'] === 'verityrx';
    
    if (store.getters.brand.show_category_tile === '1') {
        show_product_view.value = false;
    } else {
        show_product_view.value = true;
    }

    showCategoryView.value = isVerityRx;
    previewParent.value = isVerityRx;

    // Handle show default view setting
    if (store.getters.brand.show_default_view === '0') {
        show_list_view.value = false;
        classForListViewRow.value = 'card card-custom';
        classForListViewColumn.value = 'card card-custom';
    }

    // Listen for product detail event
    eventBus.on('Product::openDetails', (product) => {
        openModal(product, true);
      });
    });

 const pagination = computed(() => store.state.pagination_size);

const primaryBtnColor = computed(() => {
  const color = store.state.brand_skins['shop_primary_btn_bg_color'];
  return {
    'background-color': `${color} !important`,
  };
});

const endCustomerPreview = async () => {
  if (endingCustomerPreview.value) return;

  endingCustomerPreview.value = true;
  store.commit('SHOW_LOADER', true);
  localStorage.removeItem('impersonated');

  try {
    const response = await LoginAPIService.backToBrandDashboard({
      username: store.state.remember_role,
    });

    await store.dispatch('getData', response.data);
    store.commit('SET_SHOP_CUSTOMER_ID', '');
    window.location.href = '/dashboard';
  } catch (error) {
    endingCustomerPreview.value = false;
    store.commit('SHOW_LOADER', false);
    toast.error('Unable to end customer preview. Please try again.');
  }
};

const columnClass = computed(() => {
  return show_list_view.value == true ? 'col-md-3' : 'col-md-12';
});

const productSelectedForOrder = (product, index) => {
  // Call addToCart method with the selected product
  addToCart(product);
};

const addToCart = (product) => {
  const restrictSingleCategoryOrder = store.state.brand.restrict_single_category_order;

  if (restrictSingleCategoryOrder == 1) {
    const productObj = product.hasVariants ? selectedVariant.value : product;
    const cartProducts = store.state.cartProducts;
    const categoryId = product.cat_id ?? product.category?.id;
  // Check if there's already a product from a different category in the cart
    const hasDifferentCategoryProduct = cartProducts.some(cartProduct => 
      cartProduct.category_id !== categoryId 
    );
    // Allow products from the same category; throw error only if product from another category is added
    if (hasDifferentCategoryProduct) {
      Swal.fire({
        icon: "error",
        title: "Oops!",
        text: "You cannot add products from different categories at the same time.",
      });
      return;
    }
  }
// Add product to cart logic here
  const inputQuantity = store.state.brand_settings['allow_decimal_order_quantity'] == "1"
    ? parseFloat(product.min_pur_qty) 
    : parseInt(product.min_pur_qty);
  
  const productId = product.id;
  store.commit('SHOW_LOADER', true);
  ShopAPIService.addToCart({
    quantity: inputQuantity,
    productId: productId
  })
    .then((response) => {
      if (response.data.hasOwnProperty("success")) {
        store.commit('SHOW_LOADER', false);
        eventBus.emit('refreshCart');
        toast.success(response.data.success);
      } else if (response.data.hasOwnProperty("error")) {
        toast.error(response.data.error);
      }
    })
    .catch((error) => {
      store.commit('SHOW_LOADER', false);
      toast.error('Product not found');
    });
};

const loadShopData = ( pNumber = pageNumber.value, pSize = paginationSize.value, e = '') => {
  if (e.key === 'Enter' || e.keyCode === 13) {
    if (searchValue.value.length === 0) {
      toast.error('Please, Type a Product number or SKU...');
      return;
    }
  }

  store.commit('SHOW_LOADER', true);
  componentKey.value += 1;

  ShopAPIService.getShop(pNumber, pSize, searchValue.value, sortingType.value, selectedCategory.value, 
  product_collection_sort_check.value).then((response) => {
      store.commit('SHOW_LOADER', false);
      categoriesListDropDown.value = [];

      listOfCategories.value = response.data.categoriesList.filter(v => v.show_category_tile === 1);

      subCategories.value = listOfCategories.value.filter((category) => {
        if(category.parent_id === null) { 
            return false; 
        }
        return category.parent_id == selectedCategory.value; // Use == for loose equality
      });

    // subCategories.value = listOfCategories.value.filter(category => category.parent_id == selectedCategory.value);
      shopSettings.value = response.data.settings;

      let productCollection = response.data.productLists;
      productCollection.forEach(element => { element.id = 'col' + element.id; });

      if (response.data.hasOwnProperty("products")) {
        // Filter out sold-out products 
        const variants = response.data?.productVariants?.filter(v => v.so !== true) || [];
        productsList.value = response.data.PaginationData.data;
        productVariants.value = variants;

        if (productCollection.length > 0 && product_collection_sort_check.value) {
          // for first time there is no category select before Api call so we are getting the product collection which have default product sorting value is 1
          product_collection_filter.value = productCollection.find(item => item.default_product_sorting == 1);
          selectedCategory.value = product_collection_filter.value ? product_collection_filter.value.id : selectedCategory.value;
          //  now we set the value is false becuase we run if body on very first time only
          product_collection_sort_check.value = false;
        }

        paginatedData.value = response.data.PaginationData;
        productLength.value = paginatedData.value.total;
        if(categoriesList.value.length > 0){
          categoriesBreadCrumbs.value = [];
          categoriesList.value = [];
          categoriesListDropDown.value = [];
        }
        //  In category tree view we are getting those categories whoes show_category_tile is 1 (if in child show_category_tile )
        categoriesList.value = response.data.categories.filter(v => v.show_category_tile == 1);
        
        categoriesList.value = response.data.categories;

        let productList = categoriesList.value.concat(productCollection);
        const categorySortOrder = store.getters.brand.category_sort_order;
        if (categorySortOrder === 'name') {
          productList.sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: 'base' }));
        } else if (categorySortOrder === '-name') {
          productList.sort((a, b) => b.name.localeCompare(a.name, undefined, { sensitivity: 'base' }));
        }
        categoriesIndexes(productList);

        categoriesBreadCrumbs.value.push({name: 'Categories', categories: categoriesList.value,});

        if (response.data.unpaidOrders) {
          order_link.value = response.data.unpaidOrders.ordersLink;
          order_text.value = response.data.unpaidOrders.ordersText;
        }
      } else if (response.data.hasOwnProperty("error")) {
        toast.error(response.data.error);
      }
    })
    .catch((error) => {
      store.commit('SHOW_LOADER', false);
      toast.error('Something went wrong on server side!');
    });
};

const onPageSizeChange = (value) => {
  paginationSize.value = parseInt(value);
  loadShopData(pageNumber.value, paginationSize.value);
};



const loadImageGallery = ({ product, index: i }) => {
  productImage.value = product?.formatted_images?.images;
  index.value = i;
};

const openModal = (productData, variantDetails) => {
  product.value = productData;
  openVariantModal.value = ProductVariants;
  nextTick(() => {
  eventBus.emit('ProductVariants::openModal', {open: true, variants_details: variantDetails, product: productData});
  });
};

const sortingChange = () => {
      loadShopData(pageNumber.value, paginationSize.value);
    };

const sortByCategory = (event) => {
      enableFilter.value = true;
      loadShopData(pageNumber.value, paginationSize.value);
    };

const switchProductCategoryPage = () => {
  if (!show_product_view.value) {
    product_view_text.value = store.getters.brand.subdomain === 'verityrx' 
      ? t('View Categories') 
      : t('View Category List');
    toggler.value = true;
    show_product_view.value = true;
  } else {
    product_view_text.value = t('View Product List');
    toggler.value = false;
    show_product_view.value = false;
  }
};

const switchProductListView = () => {
  show_list_view.value = true;
  classForListViewRow.value = 'row';
  classForListViewColumn.value = 'col-md-3';
};

const switchProductGridView = () => {
  show_list_view.value = false;
  classForListViewRow.value = 'card card-custom';
  classForListViewColumn.value = 'card card-custom';
};

const switchCategoryTreeView = () => {
  showCategoryView.value = true;
  previewParent.value = true;
};

const switchCategoryListView = () => {
  showCategoryView.value = false;
  previewParent.value = false;
};

const filteringCategory = (category) => {
  selectedCategory.value = category;
  enableFilter.value = true;
  loadShopData(pageNumber.value, paginationSize.value);
  switchProductCategoryPage();
};

const subCategoryProduct = (id) => {
  selectedCategory.value = id;
  loadShopData(pageNumber.value, paginationSize.value);
};

const breadCrumbs = ({ category, direction, index = 0 }) => {
  if (direction === 'fwd') {
    if (category.children.length > 0) {
      categoriesBreadCrumbs.value.push({ name: categoryName(category.name), categories: category.children });
      isSubcategory.value = true;
      categoriesList.value = category.children;
    }
  } else if (direction === 'bwd') {
    if (categoriesBreadCrumbs.value.length - 1 !== index) {
      categoriesList.value = categoriesBreadCrumbs.value[index].categories;
      for (let i = index; i < categoriesBreadCrumbs.value.length; i++) {
        categoriesBreadCrumbs.value.pop();
      }
    }
  }
};

const categoriesIndexes = (categories, level = 0, prefix = '-') => {
  if (categories) {
    for (let i = 0; i < categories.length; i++) {
      categories[i]['level'] = level;
      categories[i].name = isBambuFranchising.value ? categories[i].name : prefix.concat(categories[i].name);
      categoriesListDropDown.value.push(categories[i]);
      categoriesIndexes(categories[i].children, level + 1, prefix.concat('-'));
    }
  }
};

const categoryName = (name) => {
  name = name.split('-');
  for (let i = 0; i < name.length; i++) {
    if (name[i] !== '') {
      return name[i];
    }
  }
};

const clearCategoryFilter = () => {
  enableFilter.value = false;
  selectedCategory.value = '';
  sortingType.value = store.getters.brand.shop_sort_by_default;
  loadShopData(pageNumber.value, paginationSize.value);
};


</script>
<style src="vue-multiselect/dist/vue-multiselect.css"></style>
<style scoped>
    .btn.btn-success{
        background-color: #1bac94 !important;
    }
   .subcategory-0 {
   margin-left: 0;
   }
   .subcategory-1 {
   margin-left: 8px;
   }
   .subcategory-2 {
   margin-left: 16px;
   }
   .subcategory-3 .md-text {
   margin-left: 24px;
   }
   .spinner{
    position: fixed;
    top: 0;
    left: 50%;
    bottom: 0;
    right: 0;
    display: grid;
    place-items: center;
    z-index: 111;
   }
   .breadcrumb-item a{
    cursor:pointer;
   }
   .pagination{
    justify-content: space-between;
   }
   .mobile-buttons{
            margin-top: 0.5rem !important;        
    }
    .mobile-end-customer-preview {
        display: none;
    }
    @media (max-width: 768px) {
        .mobile-end-customer-preview {
            position: fixed;
            right: 16px;
            bottom: calc(50px + env(safe-area-inset-bottom));
            z-index: 1050;
            display: inline-flex;
            align-items: center;
            gap: 0.5rem;
            padding: 0.75rem 1rem;
            color: #fff;
            font-weight: 600;
            background-color: #e76450;
            border: 0;
            border-radius: 999px;
            box-shadow: 0 4px 14px rgba(0, 0, 0, 0.22);
        }
        .mobile-end-customer-preview:disabled {
            cursor: wait;
            opacity: 0.65;
        }
        .category-view-controls {
            width: 100%;
            flex-wrap: nowrap !important;
            gap: 0.5rem;
        }
        .category-view-controls > .btn,
        .category-view-controls > .btn-group {
            margin-right: 0 !important;
        }
        .category-view-controls .btn {
            padding-right: 0.55rem;
            padding-left: 0.55rem;
            white-space: nowrap;
        }
        .category-view-controls .btn-group .btn + .btn {
            margin-left: 0.5rem !important;
        }
        .mobile-product-search {
            width: calc(100% - 30px) !important;
            margin-right: 15px;
            margin-left: 15px;
        }
        .mobile-select {
            --select-right-edge: 4px;
            flex: 0 0 50%;
            width: 50%;
            min-width: 0;
            position: relative;
            box-sizing: border-box;
            padding-right: 4px;
        }
        .mobile-select + .mobile-select {
            --select-right-edge: 15px;
            padding-right: 15px;
            padding-left: 4px;
        }
        .mobile-select::after {
            content: "";
            position: absolute;
            z-index: 2;
            top: 1px;
            right: calc(var(--select-right-edge) + 1px);
            bottom: 1px;
            width: 28px;
            background-color: #fff;
            pointer-events: none;
        }
        .mobile-select::before {
            content: "";
            position: absolute;
            z-index: 3;
            top: 50%;
            right: calc(var(--select-right-edge) + 9px);
            border: 4px solid transparent;
            border-top-color: #6c757d;
            transform: translateY(-25%);
            pointer-events: none;
        }
        .mobile-select select {
            width: 100%;
            min-width: 0;
            max-width: 100%;
            margin-right: 0 !important;
            padding-right: 32px !important;
            -webkit-appearance: none;
            appearance: none;
            background-color: #fff;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
        @supports (appearance: base-select) {
            .mobile-select select,
            .mobile-select select::picker(select) {
                appearance: base-select;
            }
            .mobile-select select::picker-icon {
                display: none;
            }
            .mobile-select select::picker(select) {
                inline-size: anchor-size(width);
                min-inline-size: anchor-size(width);
                max-inline-size: anchor-size(width);
                box-sizing: border-box;
            }
            .mobile-select select option {
                white-space: normal;
                overflow-wrap: anywhere;
                line-height: 1.25;
            }
        }
    }
    .btn-primary, .btn-success, .btn-dark, .btn-danger, .btn-warning, .btn-light, .btn-info, .btn-secondary, .btn-outline-primary, .btn-light-primary{
        border-radius: 5px !important;
    }
    .card-brands{
        width: 250px;
        float: right;
    }
    @media (min-width: 992px) { 
    .content {
		padding: 40px !important;
    }
 }
 .subheader {
     display: -webkit-box;
     display: -ms-flexbox;
     display: flex;
     -webkit-box-align: center;
     -ms-flex-align: center;
     align-items: center;
     border-top-right-radius: 0.42rem;
     background-color: #f9f9fc;
}
 .subheader .subheader-separator {
     display: block;
     width: 12px;
     height: 4px;
     border-radius: 2px;
}
 .subheader .subheader-separator.subheader-separator-ver {
     width: 1px;
     height: 22px;
}
 @media (min-width: 992px) {
     .subheader {
         border-top-left-radius: 0;
         padding: 0 40px;
    }
}
 @media (max-width: 991.98px) {
     .subheader {
         padding: 0 15px;
         border-top-left-radius: 0.42rem;
         border-top-right-radius: 0.42rem;
    }
}
.custom-card{
    max-width: 300px;
    margin: 0 auto;
    max-height: 475px;
}
.bg-img-height {
    height: 250px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    max-width: 235px;
    cursor: pointer;
}
.vgs{
    transition: opacity .2s ease;
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    min-height: 100%;
    height: 100vh;
    background-color: rgba(0,0,0,.8);
    display: table;
  }
  .vgs__close{
    color: #fff;
    position: absolute;
    top: 0;
    right: 0;
    background-color: transparent;
    border: none;
    font-size: 25px;
    width: 50px;
    height: 50px;
    cursor: pointer;
    z-index: 999;
  }
  .vgs__container{
    position: absolute;
    overflow: hidden;
    cursor: pointer;
    overflow: hidden;
    max-width: 100vh;
    margin: .5rem auto 0;
    left: .5rem;
    right: .5rem;
    height: 60vh;
    border-radius: 12px;
    background-color: #000;
  }
  .vgs__container__img{
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  img {
  vertical-align: middle;
  border-style: none;
}
.pagination {
  display: flex !important;
  visibility: visible !important;
}

</style>
